
function init() {
  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  document.querySelectorAll('.profile__btn').forEach(el => {

    const controlled = el.parentElement.querySelector('.profile__text');
    var expandable = false;

    if (iOSSafari || isSafari) {
      const parentElement = el.parentElement.parentElement;
      parentElement.classList.add('profile--fallback');
      expandable = true;
    } else {
      expandable = controlled.offsetHeight < controlled.scrollHeight;
    }

    el.addEventListener('click', e => {
      const open = controlled.getAttribute('aria-expanded') !== 'false';

      controlled.setAttribute('aria-expanded', open ? 'false' : 'true');
      el.setAttribute('aria-expanded', open ? 'false' : 'true');
      el.textContent = open ? 'Read more' : 'Read less';

      e.preventDefault();
    });

    if (expandable) {
      el.style.display = 'inline-block';
    } else {
      el.style.display = 'none';
    }


  });

}




document.addEventListener('DOMContentLoaded', () => {
  init();
  var windowWidth = window.innerWidth

  window.addEventListener('resize', function(e) {
    if (window.innerWidth != windowWidth) {

      // Update the window width for next time
      windowWidth = window.innerWidth

      init();

    }
  });
});
